import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage';
import SearchPage from "./pages/SearchPage";
import LoginPage from "./pages/LoginPage";
import AddProductPage from "./pages/AddProductPage";
import AdminDashboard from './pages/AdminDashboard';
import ProductListPage from './pages/ProductListPage';
import EditProductPage from './pages/EditProductPage';
import UploadExcelPage from './pages/UploadExcelPage';
import ProductDetailPage from './pages/ProductDetailPage';
import SettingsPage from './pages/SettingsPage';
import PrivateRoute from './components/PrivateRoute';
import Toast from './components/Toast';

function App() {
    return (
        <Router>
            <Toast />
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/search" element={<SearchPage />} />
                <Route path="/product/:id" element={<ProductDetailPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/admin/dashboard" element={<PrivateRoute><AdminDashboard /></PrivateRoute>} />
                <Route path="/admin/add-product" element={<PrivateRoute><AddProductPage /></PrivateRoute>} />
                <Route path="/admin/products" element={<PrivateRoute><ProductListPage /></PrivateRoute>} />
                <Route path="/admin/edit-product/:id" element={<PrivateRoute><EditProductPage /></PrivateRoute>} />
                <Route path="/admin/upload-excel" element={<PrivateRoute><UploadExcelPage /></PrivateRoute>} />
                <Route path="/admin/settings" element={<PrivateRoute><SettingsPage /></PrivateRoute>} />
            </Routes>
        </Router>
    );
}

export default App;